
export function capitalizeFirst(word: string = ''): string {
  const cleaned = word.trim();
  return cleaned
    ? cleaned[0].toUpperCase() + cleaned.slice(1).toLowerCase()
    : '';
}

export function toLowerCase(value: string): string {
  return value ? value.toLowerCase() : '';
}
